import styled from 'styled-components';

//* ** CSS ***//
export const BalanceUl = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding-left: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  ${(p) => p.isMobile && 'justify-content: space-between;'}
  ${(p) => p.isMobile && 'width: 100%;'}
`;

export const BalanceUlSingle = styled(BalanceUl)`
  flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
  ${(p) => p.isMobile && 'gap: 8px;'}
`;

export const BalanceLi = styled.li`
  ${(p) => p.theme.typographyRebrand.body.sm}
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  margin-right: 25px;
  ${(p) => p.isMobile && 'margin-left: 25px;'}
  flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
  gap: 4px;
`;

export const BalanceLiSingle = styled(BalanceLi)`
  flex-direction: row;
  color: ${(p) => (p.isMobile ? p.theme.c.text.primary : p.theme.c.text.interactive)};
`;

export const FirstName = styled.div`
  text-transform: uppercase; 
`;

export const BalanceAmount = styled.span`
  ${(p) => (p.isMobile ? p.theme.typographyRebrand.heading.lg : p.theme.typographyRebrand.body.sm)}

  display: flex;
  align-items: center;
`;

export const BalanceLabel = styled.span`
  ${(p) => p.theme.typographyRebrand.body.sm}

  display: flex;
  align-items: center;
  th
  padding-left: 4px;
`;
